<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col :cols="inputColumns" class="pb-0">
        <v-text-field
          v-model="formData.name"
          outlined
          dense
          label="* Customer name"
          :rules="[formRules.required]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="inputColumns" class="pb-0">
        <v-textarea
          v-model="formData.description"
          outlined
          dense
          label="Description"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="inputColumns" class="py-0">
        <v-text-field
          v-model="formData.email"
          outlined
          dense
          label="* Main email"
          :rules="[formRules.required, formRules.email]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="inputColumns" class="py-0">
        <v-text-field
          v-model="formData.phone"
          outlined
          dense
          label="Main phone"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="inputColumns" class="pt-0">
        <v-text-field
          v-model="formData.wiki"
          outlined
          dense
          label="Wiki link"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-divider class="pb-4"></v-divider>

    <v-row>
      <v-spacer></v-spacer>

      <v-col cols="auto">
        <slot name="buttons-before"></slot>

        <v-btn depressed color="primary" @click="submit" :disabled="!valid"
          >Save</v-btn
        >

        <slot name="buttons-after"></slot>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CustomerCreateEditForm',
  data: () => ({
    valid: false,
    formData: {
      id: null,
      name: '',
      description: '',
      email: '',
      phone: '',
      wiki: ''
    },
    formRules: {
      required: v => !!v || 'This field is required.',
      email: v => /.+@.+\..+/.test(v) || 'Must be a valid email.'
    }
  }),
  computed: {
    ...mapGetters('customers', ['customer']),
    inputColumns() {
      return this.formData.id ? 6 : 12
    }
  },
  methods: {
    ...mapActions('customers', ['storeCustomer', 'updateCustomer']),
    setFormData() {
      this.formData.id = this.customer.id
      this.formData.name = this.customer.name
      this.formData.description = this.customer.description
      this.formData.email = this.customer.email
      this.formData.phone = this.customer.phone
      this.formData.wiki = this.customer.wiki
    },
    submit() {
      if (this.formData.id) {
        this.updateCustomer(this.formData)
      } else {
        this.storeCustomer(this.formData)

        this.$refs.form.reset()
      }

      this.$emit('submitted')
    }
  },
  mounted() {
    if (this.$route.params.customer_id) {
      this.setFormData()
    } else {
      this.$refs.form.reset()
    }
  }
}
</script>
